.footerButton {
  min-height: 44px;
}
